import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICashbacksRedeemed } from '../model/cashbacks.redeemed';
import { GenericResponse } from '../model/generic.response';
import { AppSettings } from '../settings/app-settings';

@Injectable({ providedIn: 'root' })
export class WholesalerService {
    constructor(
        private http: HttpClient
    ) { }

    getCashbacksRedeemed(wholesalerId: string, queryParams: any) {
        const params = new HttpParams({ fromObject: queryParams });
        const path = AppSettings.GET_WHOLESALER_CASHBACKS_REDEEMED.replace('@1@', wholesalerId);

        return this.http.get<GenericResponse<ICashbacksRedeemed[]>>(
            AppSettings.API_ENDPOINT + path,
            { params },
        );
    }

    generateApiKey(id: any) {
        const path = AppSettings.API_ENDPOINT
            + AppSettings.CREATE_ROTATE_WHOLESALER_API_KEY.replace('@1@', id);

        return this.http.post<GenericResponse<any>>(
            path, {}
        );
    }
}
